<div class="page-title-area page-title-area-three title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Our Valuable Clients</h2>
                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Our Valuable Clients</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="practice-details-area pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="section-title text-start">
                    <h2>List Of Our Clients</h2>
                </div>
            </div>
        </div>

        <br />
        <div class="row align-items-start">
            <ng-container *ngFor = "let image of images; let index = i">
                <div class="col-6 col-sm-4">
                    <div class="card custom-card">
                        <img [src]=image class="card-img-top" [alt]="index" height="100px">
                    </div>        
                </div>
            </ng-container>
        </div>

    </div>

</section>